import { useEffect } from "react";
import { messaging, onMessage } from "./firebase";
// import toast from "react-hot-toast";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { fetchNotifications } from "./store/slices/notificationSlice";

const useFirebaseMessaging = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Listen for foreground FCM messages
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('Foreground Message received: ', payload);
      
      // Production strategy: Refresh the store to get the full actionable notification object
      // (This ensures we have metadata like order_id for navigation)
      dispatch(fetchNotifications());

      // Display a high-visibility toast
      if (payload.notification) {
        toast.info(
          <div className="custom-toast">
            <h6 className="fw-bold mb-1">{payload.notification.title}</h6>
            <p className="mb-0 small">{payload.notification.body}</p>
          </div>,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      }
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [dispatch]);

  return { loading: false };
};

export default useFirebaseMessaging;
